import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            info: {},
            error: {},
        };
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
            info,
            error,
        });
    }

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return <div className="react-error">

                <h1>Something went wrong</h1>

            </div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/ErrorBoundary.jsx